let arrival_data8 = [
    {
        id : 28,
        imgurl : '/img/newarrival/section3_golf5.jpg',
        brand : 'GFORE',
        title : '23SS GS 써클 로고 골프 썬캡 블랙',
        persent : '6%',
        price : '97,900',
        saleprice : '91,050',
    },
    {
        id : 29,
        imgurl : '/img/newarrival/section3_golf6.jpg',
        brand : 'MONTBELL',
        title : '위크론 스트라이프 티',
        persent : '',
        price : '',
        saleprice : '49,000',
    },
    {
        id : 30,
        imgurl : '/img/newarrival/section3_golf7.jpg',
        brand : 'FILA',
        title : '[FILA] 휠라 퐁 쏭',
        persent : '30%',
        price : '29,000',
        saleprice : '20,300',
    },
    {
        id : 31,
        imgurl : '/img/newarrival/section3_golf8.jpg',
        brand : 'CHAMPION',
        title : 'C로고 Classic Jersey 5.5oz 반팔티셔츠',
        persent : '',
        price : '',
        saleprice : '39,000',
    },
]

export default arrival_data8